import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@design-system/tooltip';
export const AddOptionalTooltip = ({ children, tooltip, }) => tooltip ? (_jsx(Tooltip, { childrenElement: tooltip, hideOnScreenReader: true, children: children })) : (children);
//# sourceMappingURL=AddOptionalTooltip.js.map